<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/" class="linkstyle">展覽列表</a
          ><span>/</span> <em name="Exhibition"></em>
          <span>/</span>買主資料即時GET
        </div>
        <div>
          <span class="bold">登入帳號 :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div class="MbDevice">
        <div class="homeLeft mt-5">
          <div class="UserAccount ml-1">
            <span class="bold">登入帳號 :</span>
            <span> {{ UserId }}</span>
          </div>
          <hr />
          <div class="expoLogo">
            <img :src="ExhLogo" width="100%" />
          </div>

          <div class="expoInfo">
            <p class="bold" name="Exhibition">{{ ExhibitionName }}</p>
            <p>{{ Exhdate }}</p>
            <p>{{ ExhVenue }}</p>
          </div>
          <p class="clear"></p>
        </div>
      </div>
      <div class="contentBox">
        <!-- left -->
        <div class="proLeft NoShowInMobile align_c">
          <img src="../../../assets/images/iconApp.svg" width="100%" />
        </div>
        <!-- left end -->
        <div class="proRight">
          <div class="MbDevice">
            <div class="d-flex align-items-center">
              <div>
                <img
                  src="../../../assets/images/iconApp.svg"
                  width="35px"
                  class="mt-1 mr-1"
                />
              </div>
              <div>
                <h1>買主資料即時GET</h1>
              </div>
            </div>
          </div>
          <div class="PcDevice">
            <h1>買主資料即時GET</h1>
          </div>

          <p class="my-3">&nbsp;</p>
          <p>
            參展廠商可透過「展昭掃描器APP」掃描參觀者的電子會員卡條碼獲取參觀者之基本資訊，內容包含參觀者之姓名、公司名稱、部門、職稱、電話、Email及國籍等個人資料。
          </p>
          <p class="my-3">&nbsp;</p>
          <div class="hide">
            <p>
              開放時間：<span class="red" name="OpenDay"></span> ( 展前1天 )
            </p>
            <p>
              掃描時間：<span class="red" name="date">{{ Exhdate }}</span> (
              展覽期間 )
            </p>
            <p>
              關閉時間：<span class="red" name="CloseDay"></span> ( 展後30天 )
            </p>
            <p class="my-3">&nbsp;</p>

            <div class="d-flex">
              <div id="btnColor">
                <a
                  :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/upgradeGetCard?no=${RegNo}`"
                  data-fancybox
                  data-type="iframe"
                  data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                  class="iframeFull btnStyle linkstyle"
                  >資料收集</a
                >
              </div>

              <!-- <div id="btnColor" class="ml-4">
                <a
                  :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/upgradeGetCardInfo?no=${RegNo}`"
                  data-fancybox
                  data-type="iframe"
                  data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                  class="iframeFull btnStyle linkstyle"
                  >帳號管理</a
                >
              </div> -->
            </div>
          </div>
          <p class="lightLine">&nbsp;</p>
          <h3>展昭掃描器APP</h3>
          <p class="my-3">&nbsp;</p>
          <h4>簡單3步驟，買主資料跟你走！</h4>
          <p class="my-3">&nbsp;</p>
          <ol class="number">
            <li>至 App Store 或是 Google Play 搜尋「展昭掃描器」並下載安裝</li>
            <li>開啟展昭掃描器APP後，使用參展商管理系統帳號密碼登入</li>
            <li>
              第一次進入請先點選 >「掃描資料」>「選擇展覽」選擇所參加的展覽
            </li>
          </ol>
          <p class="my-3">&nbsp;</p>
          <img
            src="../../../assets/images/appDownload.jpg"
            class="picForMobile"
          />
          <p class="my-3">&nbsp;</p>
          子帳號管理、標籤、資料匯出...等更多功能請點此<a
            target="_blank"
            class="linkstyle"
            href="//www.chanchao.com.tw/qa/getBuyer/app/"
            >操作教學</a
          >
          <p class="lightLine">&nbsp;</p>
          <h3>聯繫業務</h3>
          <p class="my-3">&nbsp;</p>
          <div name="ExpoContact"></div>
        </div>
        <p class="clear"></p>
        <p class="my-3">&nbsp;</p>
        <div class="alert">
          <p class="bold">服務說明與規範</p>
          <p class="divider">&nbsp;</p>
          <ol class="number">
            <li>使用時間：<span name="date"></span></li>
            <li>
              使用租金：每一App帳號優惠價為新台幣5,250元未稅
              (原價新台幣6,300元未稅)
            </li>
            <li>
              帳號建立後請先下載專用App(展昭掃描器)，各項功能將於<span
                name="OpenDay"
              ></span
              >申請完成後開放使用，每一母帳號僅限新增三個子帳號。
            </li>
            <li>
              展覽期間掃描之資料可至參展商管理系統中查詢下載，大會將於<span
                name="CloseDay"
              ></span
              >關閉App功能及參展商管理系統資料頁面，敬請留意時間。
            </li>
            <li>
              參觀者保有提供條碼之決策權。若無意願，參展廠商不得強行掃描；若有爭議，請至大會服務台洽詢主辦單位。
            </li>
            <li>
              參觀買主之個人資料皆為主辦單位遵守中華民國「個人資料保護法」之規範下所收集獲得，儲存於各買主QR
              Code連結之雲端資料庫。
            </li>
            <li>
              買主之入場QR
              Code等同買主之電子名片，開通此服務之參展廠商可透過掃描買主QR
              Code獲得該買主之個人資料（包含姓名、公司、部門、職稱、電話、Email、及國籍）；上述個資皆為買主線上登錄時所自行填入，主辦單位不擔保資料之完整性及正確性。
            </li>
            <li>
              買主有權決定是否允許參展廠商掃描其QR
              Code（正如買主可自行決定是否提供其個人名片），此服務不表示參展廠商有權擁有所有買主資料，參展廠商僅可獲得掃描到QR
              Code的買主個資。
            </li>
            <li>
              參展廠商取得之買主資料，僅供貴公司自行使用，請務必遵守中華民國「個人資料保護法」之規範妥善維護，不得非法變賣或提供他人。
            </li>
            <li>
              請勿以非法方式使用本系統，若發現任何不當之使用行為，主辦單位有權逕行終止此項服務。
            </li>
          </ol>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  components: {},

  metaInfo() {
    return {
      title: "買主資料即時GET - 展昭參展商管理系統",
    };
  },

  data() {
    return {
      Exhdate: "",
      ExhVenue: "",
      ExhibitionName: "",
      UserId: "",
      RegNo: "",

      ExhLogo: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",
      VisitorGetQuota: "",
    };
  },

  methods: {},

  created() {
    const vm = this;

    let lang = "tw";

    //url取出展碼
    let nowPage = location.href;
    vm.RegNo = nowPage.split("no=")[1];

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${lang}`
      )
      .then((response) => {
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`;
        vm.ExhBegin = response.data.Data.ExhBegin;
        vm.ExhEnd = response.data.Data.ExhEnd;
        vm.ExhVenue = response.data.Data.ExhVenue;
        vm.eExhVenue = response.data.Data.eExhVenue;
      });

    $(function () {
      let lang = "tw";
      $.getJSON(
        "/apiExhibitors/Exhibition/" + vm.RegNo,
        { lang: lang },
        function (data) {
          //exh detail
          $('[name="date"]').text(
            data.Data.ExhBegin + " - " + data.Data.ExhEnd
          );

          //OpenDay
          var OpenDay = new Date(data.Data.ExhBegin);

          OpenDay.setDate(OpenDay.getDate() - 1);
          $('[name="OpenDay"]').text(formatDate(OpenDay));

          function formatDate(date) {
            var d = new Date(date),
              month = "" + (d.getMonth() + 1),
              day = "" + d.getDate(),
              year = d.getFullYear();
            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            return [year, month, day].join("/");
          }

          //close day
          var CloseDay = new Date(data.Data.ExhEnd);
          CloseDay.setDate(CloseDay.getDate() + 30);
          $('[name="CloseDay"]').text(formatDate(CloseDay));
        }
      );

      //contact info
      $.getJSON(
        "/apiExhibitors/AdvContact/" + vm.RegNo,
        { lang: lang },
        function (data) {
          $('[name="ExpoContact"]').html(data.Data.AdvContact);

          // console.log(data)
        }
      );

      // AddReg() //按鈕加上網址參數

      // $('.iframeFull').fancybox({
      //   iframe: {
      //     css: {
      //       height: '100%',
      //     },
      //   },
      // })

      //避免未登入pop-up錯誤
      // $('a.iframeFull').click(function () {
      //   LoginCheck()
      // })
    });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //取得使用者數量限制
    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`)
      .then((response) => {
        vm.VisitorGetQuota = response.data.Data.VisitorGetQuota;
      });
  },
};
</script>

<style lang="scss">
#btnColor a:hover {
  color: #ffffff;
}
</style>
